// extracted by mini-css-extract-plugin
export default {"root":"Z9W3M_Z9W3M","inputContainer":"TByBx_TByBx","tagContainer":"b1grT_b1grT","noTagsMessage":"GLT8R_GLT8R"};